import { render, staticRenderFns } from "./CollegeTaskGuideBody.vue?vue&type=template&id=65b6d540&scoped=true&"
import script from "./CollegeTaskGuideBody.vue?vue&type=script&lang=js&"
export * from "./CollegeTaskGuideBody.vue?vue&type=script&lang=js&"
import style0 from "./CollegeTaskGuideBody.vue?vue&type=style&index=0&id=65b6d540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b6d540",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VChip,VIcon,VTimeline,VTimelineItem})
